import { ROUTE_SIGNUP } from '@/constants/Routes'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

type Props = {
  title: string
  href: string
  trackEvent?: (viewName: string) => void
  openIFrameModal?: () => void
}

export const MenuItem = ({ title, href, trackEvent, openIFrameModal }: Props) => {
  const { t } = useTranslation()

  return (
    <Link
      to={href}
      className={`px-3 py-3 font-semibold hover:bg-slate-700 hover:rounded ${
        href === ROUTE_SIGNUP ? 'bg-white rounded text-darkNavy text-sm hover:opacity-90 hover:bg-white' : 'text-white'
      }`}
      onClick={() => {
        if (trackEvent) trackEvent(title)
        if (openIFrameModal) openIFrameModal()
      }}
    >
      {t(`common.${title}`)}
    </Link>
  )
}
